import React, { useContext } from 'react';

import VulnerabilitySummaryLayout from '@totem/components/software/vulnerabilitySummary/SummaryLayout';
import VulnerabilitySummaryContext from '@totem/components/software/vulnerabilitySummary/vulnerabilitySummaryContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import DeviceSummaryLayout from '@totem/components/vulnerabilities/overviewSummary/deviceSummaryLayout';
import VulnerabilitySummaryContextOverview from '@totem/components/vulnerabilities/overviewSummary/vulnerabilitySummaryContext';
import { isNull } from '@totem/utilities/common';

const VulnerabilityConditional = () => {
  const { data } = useContext(VulnerabilitySummaryContext);
  const { data: overviewData } = useContext(
    VulnerabilitySummaryContextOverview,
  );

  if (isNull(data) && isNull(overviewData)) {
    return null;
  }

  return (
    <IBCard title={'Vulnerabilities'} isCovered>
      <VulnerabilitySummaryLayout />
      <DeviceSummaryLayout />
    </IBCard>
  );
};

export default VulnerabilityConditional;
